import { render } from "./Catalogo.vue?vue&type=template&id=e1e45284&scoped=true"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"

import "./Catalogo.vue?vue&type=style&index=0&id=e1e45284&scoped=true&lang=scss"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e45284"]])

export default __exports__